import { combineReducers, configureStore } from '@reduxjs/toolkit';

import configReducer from './slices/configSlice';
import userReducer from './slices/userSlice';
import moviesReducer from './slices/moviesSlice';

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
  config: configReducer,
  user: userReducer,
  movies: moviesReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
